// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"489":"47d1005e","655":"727dfe17","697":"5c374817","787":"4a10c159"}[chunkId] + ".chunk.js";
};